import { render, staticRenderFns } from "./approve-export.vue?vue&type=template&id=5ed9f796&scoped=true"
import script from "./approve-export.vue?vue&type=script&lang=js"
export * from "./approve-export.vue?vue&type=script&lang=js"
import style0 from "./approve-export.vue?vue&type=style&index=0&id=5ed9f796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9f796",
  null
  
)

export default component.exports